var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerpath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1282.417,
    height: 193.496,
    viewBox: "0 0 1282.417 193.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8973",
    "data-name": "Path 8973",
    d: "M0,0S48.54-191.987,231.29-133.657,633.634,152.113,907.985-31.643,1280-133.657,1280-133.657",
    transform: "translate(1.454 153.283)",
    fill: "none",
    stroke: "#e385c5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerpath);
export default __webpack_public_path__ + "static/media/bannerpath.c2f07641df0ad4abfb408aeb47f5f53f.svg";
export { ForwardRef as ReactComponent };